import React, {useContext} from 'react';
import {Controller} from 'react-hook-form';
import {IListColumnProps} from '@src/@interfaces/components/List/IListColumnProps';
import {IOrderModel} from '@src/@interfaces/models/Order/IOrderModel';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import classnames from '@src/helpers/classnames';
import {IFormFieldItemPropsContext} from '@src/@interfaces/contexts/IFormFieldItemPropsContext';
import {FormFieldItemPropsContext} from '@src/contexts/FormFieldItemPropsContext';
import FormErrorMessage from '@src/components/Form/FormErrorMessage';

export function QuantityIndependentField(props: { rowIndex: number, isDisabled?: boolean }) {
    return <ActualForm {...props}/>;
}

function ActualForm({rowIndex: index, isDisabled}: { rowIndex: number, isDisabled?: boolean }) {
    const {
        control,
        fieldName,
        forceReadonly,
        forceDisabled,
    } = useContext<IFormFieldItemPropsContext<IOrderModel> | null>(FormFieldItemPropsContext) ?? {};
    const [design] = useContext(FormFieldDesignContext);

    if (!control) {
        return null;
    }

    return <>
        <Controller
                control={control}
                name={`${fieldName}.${index}.quantity`}
                render={(
                        {
                            field: {
                                ref,
                                name,
                                value,
                                onChange,
                                onBlur
                            }, fieldState: {error}
                        }
                ) => {
                    return <input
                            ref={ref}
                            name={name}
                            type="number"
                            value={value ?? 0}
                            onChange={onChange}
                            onBlur={onBlur}
                            className={classnames('form-control', {
                                'is-invalid': Boolean(error)
                            })}
                            step={0.0001}
                            min={0.0001}
                            readOnly={design.fieldsAreReadOnly || forceReadonly}
                            disabled={isDisabled || design.fieldsAreDisabled || forceDisabled}
                    />;
                }}
        />

        <FormErrorMessage fieldName={`${fieldName}.${index}.quantity`}/>
    </>;
}

export function QuantityField(props: IListColumnProps) {
    return <ActualForm {...props}/>;
}
